// State for the post-login CRM tour: step 1 points at the CRM tab, step 2 at
// the "Create Inquiry" button. The step lives for the browser session (reset
// on login); "Don't show again" is remembered permanently on this device.
const STEP_KEY = "crmTourStep";
const NEVER_KEY = "crmTourNever";

let memoryStep = null;

export const getTourStep = () => {
  try {
    if (window.localStorage.getItem(NEVER_KEY) === "1") return "done";
    return window.sessionStorage.getItem(STEP_KEY) || memoryStep || "crm";
  } catch (e) {
    return memoryStep || "crm";
  }
};

export const setTourStep = (step) => {
  memoryStep = step;
  try {
    window.sessionStorage.setItem(STEP_KEY, step);
  } catch (e) {}
};

export const neverShowTour = () => {
  setTourStep("done");
  try {
    window.localStorage.setItem(NEVER_KEY, "1");
  } catch (e) {}
};

export const resetTourForLogin = () => {
  memoryStep = null;
  try {
    window.sessionStorage.removeItem(STEP_KEY);
  } catch (e) {}
};
